<div class="dropdown-container">
  <div class="dropdown">
    <div
      class="togglable-input"
      (click)="toggle()"
      (keydown.space)="toggle()"
      (keydown.enter)="toggle()"
      tabindex="0"
    >
      @if (selectedInvestment) {
        <div class="selected-name">
          @if (selectedInvestment.dip) {
            <p class="dip-stamp-text">{{ 'global.dipShortcut' | translate }}</p>
          }
          @if (selectedInvestment.type === 'portfolio') {
            <div class="type">
              {{ 'money.portfolio' | translate }}
            </div>
          } @else {
            <div class="type">
              {{ 'money.strategy' | translate }}
            </div>
          }
          &nbsp;&#34;<div class="investment-name">{{ selectedInvestment.name }}</div>&#34;
        </div>
      }
      @if (selectedWithdrawInvestment) {
        <div class="selected-name">
          @if (selectedWithdrawInvestment.dip) {
            <p class="dip-stamp-text">{{ 'global.dipShortcut' | translate }}</p>
          }
          @if (selectedWithdrawInvestment.portfolioType === 'portfolio') {
            <div class="type">
              {{ 'money.portfolio' | translate }}
            </div>
          } @else {
            <div class="type">
              {{ 'money.strategy' | translate }}
            </div>
          }
          &nbsp;&#34;<div class="investment-name">{{ selectedWithdrawInvestment.name }}</div>&#34;
        </div>
      }
      @if (selectedBankAccount) {
        <div class="selected-name">
          {{ 'money.bankAccountName' | translate }}
        </div>
      }

      <div>
        <svg-icon src="assets/icons/chevron-down.svg" [svgStyle]="{ 'width.px':18, 'transform': toggled ? 'rotate(180deg)' : '' }"></svg-icon>
      </div>
    </div>

    @if (toggled) {
      <div class="available-list">
        @for (bankAccount of _availableBankAccounts; track bankAccount) {
          <div
            class="select-item"
            (click)="updateValue(bankAccount)"
            (keydown.space)="updateValue(bankAccount)"
            (keydown.enter)="updateValue(bankAccount)"
            tabindex="0"
            >
            {{ bankAccount.name }}
          </div>
        }
        @for (investment of availableInvestments; track investment) {
          <div
            class="select-item"
            (click)="updateValue(investment)"
            (keydown.space)="updateValue(investment)"
            (keydown.enter)="updateValue(investment)"
            tabindex="0"
            >
            {{ investment.name }}
          </div>
        }
        @for (withdrawInvestment of availableWithdrawInvestments; track withdrawInvestment) {
          <div
            class="select-item"
            (click)="updateValue(withdrawInvestment)"
            (keydown.space)="updateValue(withdrawInvestment)"
            (keydown.enter)="updateValue(withdrawInvestment)"
            tabindex="0"
            >
            {{ withdrawInvestment.name }}
          </div>
        }
      </div>
    }
  </div>

  <div class="selected-details">
    @if (selectedInvestment) {
      <div>
        <div class="selected-label">
          {{ 'money.withdrawActualValue' | translate }}
        </div>
        <div class="value">
          {{ selectedInvestment.valueWithoutPendingWithdrawals | price:loggedUser.currencyCode }}
        </div>
        @if (selectedInvestment.sumOfPendingWithdrawals > 0) {
          <div class="selected-label">
            {{ 'money.pendingWithdraws' | translate }}
          </div>
          <div class="value">
            {{ selectedInvestment.sumOfPendingWithdrawals | price:loggedUser.currencyCode }}
          </div>
        }
        @if (selectedInvestment.containsWithdrawAllRequest) {
          <div class="selected-label">
            {{ 'money.investmentStatus' | translate }}
          </div>
          <div class="value value--text">
            {{ 'money.withdrawingAll' | translate }}
          </div>
        }
      </div>
    }
    @if (selectedWithdrawInvestment) {
      <div>
        <div class="selected-label">
          {{ 'money.withdrawActualValue' | translate }}
        </div>
        <div class="value">
          {{ selectedWithdrawInvestment.balance | price:loggedUser.currencyCode }}
        </div>
      </div>
    }
    @if (selectedBankAccount) {
      <div>
        <div class="selected-label">
          {{ 'money.withdrawAccountNumber' | translate }}
        </div>
        <div class="account-number">
          {{ selectedBankAccount.accountNumber }}
        </div>
      </div>
    }
  </div>
</div>